import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { useLocation } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { FaMinusCircle } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { createNewCategory, deleteCategory, getCategorySubMenusAPI, updateCategorySubmenuPrice, updateCategoryMenu, editFieldName, getReferralAgetsDetails, deleteReferralAgent, createNewReferralAgent, getParticularReferralAgentDetails, updateReferralAgentDetails } from '../../serverApi/server'

const CreateReferral = () => {
  const location = useLocation();
  const [referralAgentUserList, setReferralAgentUserList] = useState([])
  const fetchAgentsUser = async () => {
    try {
    const getReferralAgetsDetailsAPIResponse = await getReferralAgetsDetails();
    setReferralAgentUserList(getReferralAgetsDetailsAPIResponse.data.referral_user_details_serializer)
    } catch (error) {
    console.error('Error fetching sub-menus:', error);
    }
  };

  useEffect(() => {
    fetchAgentsUser();
  }, []);

  const toggleForm = () => setFormOpen(!formOpen);
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    phoneNumber: "",
    agentDiscount: "",
    customerDiscount: "",
    totalDiscount: ""
  });

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    password: "",
    phoneNumber: "",
    agentDiscount: "",
    customerDiscount: "",
    totalDiscount: ""
  });

  const validateForm = () => {
    let isValid = true;
    let newErrors = { fullName: "", email: "", password: "", phoneNumber: "", agentDiscount: "", customerDiscount: "", totalDiscount: ""};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
      isValid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
      isValid = false;
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone Number is required";
      isValid = false;
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone Number must contain only numbers";
      isValid = false;
    }

    if (!formData.agentDiscount.trim()) {
      newErrors.agentDiscount = "Agent discount is required";
      isValid = false;
    } else if (isNaN(formData.agentDiscount)) {
      newErrors.agentDiscount = "Agent discount must be a number";
      isValid = false;
    }
  
    if (!formData.customerDiscount.trim()) {
      newErrors.customerDiscount = "Customer discount is required";
      isValid = false;
    } else if (isNaN(formData.customerDiscount)) {
      newErrors.customerDiscount = "Customer discount must be a number";
      isValid = false;
    }
  
    if (!formData.totalDiscount.trim()) {
      newErrors.totalDiscount = "Total discount is required";
      isValid = false;
    } else if (isNaN(formData.totalDiscount)) {
      newErrors.totalDiscount = "Total discount must be a number";
      isValid = false;
    }
  
    const agentDiscount = parseFloat(formData.agentDiscount);
    const customerDiscount = parseFloat(formData.customerDiscount);
    const totalDiscount = parseFloat(formData.totalDiscount);
  
    if (!isNaN(agentDiscount) && !isNaN(customerDiscount) && !isNaN(totalDiscount)) {
      if (agentDiscount + customerDiscount !== totalDiscount) {
        newErrors.totalDiscount = "Total discount must be the sum of agent and customer discounts";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.replace(/\s{2,}/g, " "),
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [userId, setUserId] = useState('')

  const updateReferralAgentUser = async (updateUserId) => {
    const getParticularReferralAgentDetailsAPIResponse = await getParticularReferralAgentDetails(updateUserId)
    if (getParticularReferralAgentDetailsAPIResponse.data.client_status_code == 200) {
      setUserId(getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.user)
      setFormData({
        fullName: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.full_name,
        email: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.email,
        password: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.user_password,
        phoneNumber: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.phone_number,
        agentDiscount: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.agent_discount,
        customerDiscount: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.customer_discount,
        totalDiscount: getParticularReferralAgentDetailsAPIResponse.data.referral_user_details_serializer.total_discount,
      });
      toggleForm()
    } 
  }

  const deleteReferralAgentUser= async (deleteUserId) => {
    const deleteReferralAgentAPIResponse = await deleteReferralAgent(deleteUserId)
    if (deleteReferralAgentAPIResponse.data.client_status_code === 200) {
      fetchAgentsUser()
    } else {
      return;
    }
  }

  const saveReferralAgent = async () => {
    if (!validateForm()) {
      console.log("Validation failed!");
      return;
    }
    const createNewReferralAgentAPIResponse = await createNewReferralAgent(formData.fullName, formData.email, formData.password, formData.phoneNumber, formData.agentDiscount, formData.customerDiscount, formData.totalDiscount)
    if (createNewReferralAgentAPIResponse && createNewReferralAgentAPIResponse.data && createNewReferralAgentAPIResponse.data.client_status_code == 400 && createNewReferralAgentAPIResponse.data.id == 1) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: createNewReferralAgentAPIResponse.data.message,
      }));
    } else if (createNewReferralAgentAPIResponse && createNewReferralAgentAPIResponse.data && createNewReferralAgentAPIResponse.data.client_status_code == 200 && createNewReferralAgentAPIResponse.data.id == 2) {
      fetchAgentsUser()
      toggleForm()
      setFormData({
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        agentDiscount: "",
        customerDiscount: "",
        totalDiscount: ""
      });
    } 
  }

  const updateAgentDetails = async () => {
    if (!validateForm()) {
      return;
    }

    const updateReferralAgentDetailsAPIResponse = await updateReferralAgentDetails(userId, formData.fullName, formData.password, formData.phoneNumber, formData.agentDiscount, formData.customerDiscount, formData.totalDiscount)
    if (updateReferralAgentDetailsAPIResponse && updateReferralAgentDetailsAPIResponse.data && updateReferralAgentDetailsAPIResponse.data.client_status_code == 200) {
      setUserId('')
      fetchAgentsUser()
      toggleForm()
      setFormData({
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        agentDiscount: "",
        customerDiscount: "",
        totalDiscount: ""
      });

    } else {
      setUserId('')
      toggleForm()
      setFormData({
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        agentDiscount: "",
        customerDiscount: "",
        totalDiscount: ""
      });
    }
  }

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>
                    Referral
                </button>
                <SlArrowRight />
                <button>
                    View All Agents
                </button>
              </div>
            </div>

            <button
              className="bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 rounded text-white mr-4 md:mr-8"
              onClick={toggleForm}
            >
              + Add Agent
            </button>
          </div>
          {formOpen && (
            <div
              className="overflow-y-auto fixed inset-0 h-full z-50 flex items-center justify-center bg-black bg-opacity-50"
              aria-hidden="true"
            >
              <div className="bg-white rounded-lg w-11/12 max-w-md max-h-[1000vh] overflow-y-auto">
                <div className="flex justify-between items-center p-4 border-b">
                  <h5 className="text-lg font-medium">Add New Referral Agent</h5>
                  <button
                    type="button"
                    className="text-gray-600 text-3xl hover:text-gray-900"
                    onClick={toggleForm}
                  >
                    &times;
                  </button>
                </div>
                <div className="p-4">
                  <form>
                    <div>
                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        placeholder="Full Name"
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.fullName}
                        onChange={handleChange}
                      />
                      {errors.fullName && <p className="text-red-500 text-sm">{errors.fullName}</p>}
                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        name="email"
                        placeholder="Email"
                        readOnly={userId ? true : false}
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Password
                      </label>
                      <input
                        type="text"
                        name="password"
                        placeholder="Password"
                        readOnly={userId ? true : false}
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Phone Number
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        placeholder="Phone Number"
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors.phoneNumber && <p className="text-red-500 text-sm">{errors.phoneNumber}</p>}
                      
                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Agent Discount
                      </label>
                      <input
                        type="text"
                        name="agentDiscount"
                        placeholder="Agent Discount"
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.agentDiscount}
                        onChange={handleChange}
                      />
                      {errors.agentDiscount && <p className="text-red-500 text-sm">{errors.agentDiscount}</p>}


                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Customer Discount
                      </label>
                      <input
                        type="text"
                        name="customerDiscount"
                        placeholder="Customer Discount"
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.customerDiscount}
                        onChange={handleChange}
                      />
                      {errors.customerDiscount && <p className="text-red-500 text-sm">{errors.customerDiscount}</p>}


                      <label
                        htmlFor="newCategory"
                        className="block text-sm text-gray-700"
                      >
                        Total Discount
                      </label>
                      <input
                        type="text"
                        name="totalDiscount"
                        placeholder="Total Discount"
                        className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                        value={formData.totalDiscount}
                        onChange={handleChange}
                      />
                      {errors.totalDiscount && <p className="text-red-500 text-sm">{errors.totalDiscount}</p>}
                    </div>
                
                  </form>
                </div>
                <div className="flex justify-end items-center p-4 border-t">
                  <button
                    type="button"
                    className="bg-red-500 hover:bg-red-400 duration-200 px-3 py-2 mr-3 text-white rounded"
                    onClick={toggleForm}
                  >
                    Close
                  </button>

                  <button
                    type="button"
                    className="bg-blue-500 hover:bg-blue-400 duration-200 px-3 py-2 text-white rounded"
                    onClick={userId ? updateAgentDetails : saveReferralAgent}
                  >
                    {userId ? "Update" : "Save"}
                  </button>

                  {/* <button
                    type="button"
                    className="bg-blue-500 hover:bg-blue-400 duration-200 px-3 py-2 text-white rounded"
                    onClick={saveReferralAgent}
                  >
                    Save
                  </button> */}

                </div>
              </div>
            </div>
          )}

          <div className='bg-white mt-10 px-3 py-4 rounded-lg'>
            <div className='flex items-center gap-3 text-sm'>
              <p className='text-neutral-500'>Filter by Role:</p>
              <div className='flex items-center gap-2'>
                
              </div>
            </div>
            <div className="overflow-x-auto table-auto">
              <table className="min-w-full bg-white mt-8" style={{ borderCollapse: 'separate', borderSpacing: '2px' }}>
                <thead>
                  <tr>
                    <th className="px-2 text-start whitespace-nowrap py-2 border border-[#48ABF7] text-white font-normal bg-blue-400" style={{ width: '1%' }}>REFERRAL NAME</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">PASSWORD</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">REFERRAL CODE</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">EMAIL</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">AGENT DISCOUNT</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">CUSTOMER DISCOUNT</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">TOTAL DISCOUNT</th>
                    <th className="px-2 sm:px-4 text-center py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                {referralAgentUserList.length > 0 ? (
                  referralAgentUserList.map((referralAgentUser) => (
                    <tr key={referralAgentUser.user}>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.full_name}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.user_password}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.referral_code}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.email}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.agent_discount}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.customer_discount}</td>
                      <td className="px-2 py-2 font-normal border border-[#48ABF7] whitespace-nowrap">{referralAgentUser.total_discount}</td>
                      <td className="px-4 py-2 border border-[#48ABF7] flex">
                        <button className="bg-blue-500 text-white py-1 px-3 rounded-full flex items-center update-btn" title="Update"
                          onClick={() => updateReferralAgentUser(referralAgentUser.user)}
                        >
                          <FaEdit className="text-sm mr-1" />
                          Update
                        </button>
                        <button
                          className="bg-red-500 text-white py-1 px-3 rounded-full flex items-center ml-2"
                          onClick={() => deleteReferralAgentUser(referralAgentUser.user)}
                        >
                          <MdDeleteOutline className="mr-[1px]" />
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-4 py-6 text-center text-neutral-600">
                        No Agents available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateReferral;

